import gql from "graphql-tag";

export const POST_JOB_DEFINITION = gql`
	mutation postJobDefinition($input: PostJobDefinitionInput!) {
		postJobDefinition(input: $input) {
			jobDefinition {
				id
			}
		}
	}
`;
